/**
 * Height of the fixed site header: an 82px bar plus a 12px spacer. Must stay
 * in step with `Navbar.module.scss` and the `main` padding-top in
 * `LayoutclientWrapper`.
 */
export const HEADER_HEIGHT = 94;

/**
 * Marks a page's own hero search bar (the landing band, the /home hero).
 *
 * While one of these is on screen the header keeps the workspace-type
 * switcher; once it scrolls up under the header, the header swaps in its own
 * compact search bar. Pages that have no hero search show the header search
 * straight away.
 *
 * Spread `HERO_SEARCH_MARKER` onto the element and query it with
 * `HERO_SEARCH_SELECTOR` so the two can't drift apart.
 */
export const HERO_SEARCH_MARKER = { 'data-hero-search': '' } as const;
export const HERO_SEARCH_SELECTOR = '[data-hero-search]';
